export default __webpack_public_path__ + "static/media/ce.a313f122.svg";